import { Display } from '@/components/Display/Display';
import { errMap, errMsgMap } from '@/utils/Page/constant';
import Error from '@/components/Mobile/Error';
import agentErrImg from '@/assets/images/mobile/agent_error.webp';
import emptyImg from '@/assets/images/res/empty.webp';
import noAuthImg from '@/assets/images/res/no-auth.webp';
import chatStore from '@/store/grtAi/chat';
import s from './style.module.scss';
import { isInApp, getEnvironment } from '@/utils/Mobile';
const AgentError = (props) => {
    const env = getEnvironment();
    const isApp = isInApp();
    let { code } = props.err;
    let img = {
        [errMap.errlink]: agentErrImg,
        [errMap.businessOff]: emptyImg,
        [errMap.noOper]: noAuthImg
    };
    const handleOutLogin = async () => {
        let res = await chatStore.handleOutLogin(false);
        if (res) {
            let origin = window.location.origin;
            window.location.replace(`${origin}/mobile/login?redirect=${encodeURIComponent(window.location.href)}`);
        }
    };
    return (
        <>
            <Display show={code !== errMap.noOper}>
                <Error text={errMsgMap[code]} img={img[code] || emptyImg}></Error>
            </Display>
            <Display show={code === errMap.noOper}>
                <Error
                    text={errMsgMap[code]}
                    img={img[code] || emptyImg}
                    action={
                        !env &&
                        !isApp && (
                            <span className={s['error-btn']} onClick={handleOutLogin} type="primary">
                                退出登录
                            </span>
                        )
                    }
                ></Error>
            </Display>
        </>
    );
};

export default AgentError;
